// layouts/MainLayout.jsx
import React, { useCallback } from "react";
import mainStyle from "../style/Main.module.css";
import SideBar from "../components/bars/SideBar";
import SettingsBar from "../components/bars/SettingsBar";
import { useNavigate } from "react-router-dom";

const MainLayout = ({ children }) => {
  const navigate = useNavigate();

  const handleWorkspaceUpdate = useCallback(() => {
    navigate("/accountsummary");
  }, [navigate]);
  return (
    <div className={mainStyle.maincontainer}>
      <div className={mainStyle.mainContainerSub}>
        <SideBar onWorkspaceUpdate={handleWorkspaceUpdate} />
        <SettingsBar />
        <div className={mainStyle.mainContent}>
          {/* <Header /> */}
          {children}
        </div>
      </div>
    </div>
  );
};

export default MainLayout;
